import { FaTimesCircle } from "react-icons/fa";
import { converterData } from "_utils/Data";
import {
  ContainerIcone,
  ContainerModalStatusErro,
  ModalErroMensagem,
  ModalErroTitulo,
  ModalInfoItem,
  ModalInfoRow,
} from "./style";

interface IProps {
  show: boolean;
  coords: { top: number; left: number };
  motivoErro: string;
  dataErro?: string | null;
}

export function ModalStatusErroDebito({ show, coords, motivoErro, dataErro }: IProps) {
  if (!show) return null;

  return (
    <ContainerModalStatusErro top={coords.top} left={coords.left}>
      {dataErro && (
        <ModalInfoRow>
          <ModalInfoItem>
            <small>Data</small>
            <span>{converterData(dataErro.split("T")[0])}</span>
          </ModalInfoItem>
        </ModalInfoRow>
      )}
      <ModalErroTitulo>
        <ContainerIcone>
          <FaTimesCircle size={14} />
        </ContainerIcone>
        Erro
      </ModalErroTitulo>
      <ModalErroMensagem>{motivoErro}</ModalErroMensagem>
    </ContainerModalStatusErro>
  );
}
